import { YAY_DOMAIN } from 'config'
import CookieJS, { CookieAttributes } from 'js-cookie'

const createCookie = (key: string) => ({
  get: (parser = 'get') => {
    const value = CookieJS[parser](key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  },
  set: (value: any, options: CookieAttributes = {}, expires?: number) => {
    CookieJS.set(key, value?.toString?.(), {
      expires: expires ?? 365,
      ...options,
    })
  },
  remove: (options: CookieAttributes = {}) => CookieJS.remove(key, options),
})

const cookie = {
  oldAppDomainLocale: createCookie('_yay_domain_locale'), // just to force remove from client
  appDomainLocale: createCookie('_yay_domain_share_locale'),
  appLocale: createCookie('_yay_web_locale'),
  appVersion: createCookie('_yay_web_version'),
  accessToken: createCookie('_yay_web_access_token'),
  refreshToken: createCookie('_yay_web_refresh_token'),
  userId: createCookie('_yay_web_user_id'),
  createGroupLimit: createCookie('_yay_web_create_group_limit'),
  twitterToken: createCookie('_yay_web_request_token_twitter_token'),
  twitterSecretToken: createCookie('_yay_web_request_token_twitter_secret'),
  lineTokenState: createCookie('_yay_web_request_token_line_token_state'),
  appleTokenState: createCookie('_yay_web_request_token_apple_token_state'),
  googleTokenState: createCookie('_yay_web_request_token_google_token_state'),
  worldcoinTokenState: createCookie(
    '_yay_web_request_token_worldcoin_token_state'
  ),
  chatSettingEternalImage: createCookie('_yay_web_chat_eternal_image_mode'),
  popularKeywords: createCookie('_yay_web_popular_keywords'),
  pushNotification: createCookie('_yay_web_push_notification'),
  newsBannerVersion: createCookie('_yay_web_news_banner_version'),
  deviceId: createCookie('_yay_did'),
  chatUuid: createCookie('_yay_cuid'),
  isPaymentProcessing: createCookie('_yay_square_payment_requested'),
}

export const clearAuthCookie = () => {
  cookie.accessToken.remove()
  cookie.refreshToken.remove()
  cookie.userId.remove()
  cookie.createGroupLimit.remove()
}

export const setLanguageCookies = (lang: string) => {
  cookie.appDomainLocale.set(lang, { domain: YAY_DOMAIN })
  cookie.appLocale.set(lang)
}

export const setPaymentProcessingCookie = (
  status: boolean,
  expires?: number
) => {
  cookie.isPaymentProcessing.set(status, {}, expires)
}

export default cookie
